import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP001_Request,
  IAPI_APP001_Response,
  IAPI_APP013_Request,
  IAPI_APP013_Response,
} from "../../../type/apiType";
import {
  IAPI_APP002_Request,
  IAPI_APP002_Response,
} from "../../../type/apiType";

// 手続履歴一覧参照API
const httpAPI_APP001 = async (
  param: IAPI_APP001_Request
): Promise<IAPI_APP001_Response> => {
  let res = await http.post(ApiUrl.API_APP001, {
    ...param,
  });
  return res.data;
};

// 手続履歴状態更新API
const httpAPI_APP002 = async (
  param: IAPI_APP002_Request
): Promise<IAPI_APP002_Response> => {
  let res = await http.post(ApiUrl.API_APP002, {
    ...param,
  });
  return res.data;
};

// 掛金届の再提出API
const httpAPI_APP013 = async (
  param: IAPI_APP013_Request
): Promise<IAPI_APP013_Response> => {
  const res = await http.post(ApiUrl.API_APP013, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP001, httpAPI_APP002, httpAPI_APP013 };
